<template>
    <div class="main-window-l">
        <div class="step-nav">
            <div class="nav-item active">
                样片观摩预约情况表
            </div>
        </div>

        <div class="center-pc tb">
            <table class="investor-table">
                <tr style="background-color:#F9F2E5;">
                    <td>电影</td>
                    <td>片长</td>
                    <td>场次时间</td>
                    <td>放映地点</td>
                    <td>操作</td>
                </tr>
                <tr v-if="appointList.length == 0">
                    <td colspan="5">暂无数据</td>
                </tr>
                <div class="tr-separate"></div>
                <tr
                    v-for="(item, index) in appointList"
                    :key="index"
                    :style="
                    index % 2 == 1
                        ? 'background-color:#F9F2E5'
                        : 'background-color:#FFFCF5'
                    "
                >
                    <td>《{{ item.filmName }}》</td>
                    <td>{{ item.filmDuration }}</td>
                    <td>{{ item.showStartTime }} - {{ item.showEndTime }}</td>
                    <td>{{ item.filmPlace }}</td>
                    <td>
                        <span class="span-btn" @click="cancelBtn(item)">取消预约</span>
                    </td>
                </tr>
            </table>
        </div>
        <div class="foo border-no">
            <button class="leftBtn" @click="goBack">返回</button>
            <button class="rightBtn" @click="toPage">预约更多项目</button>
        </div>
    </div>
</template>

<script>
import { getOrderList, cancelOrder } from '@/api/industryScreen';
import { sessionData } from "@/static/js/local.js";

export default {
    data() {
        return {
            appointList: []
        }
    },
    created() {
        let detailForm = sessionData("get", "UserInfo");
        let isInvestor = detailForm.details.some(item => item.guestType == "10" && item.verifyFlag == 1);

        if (!isInvestor) {
            this.$msgbox({
                title: "提示",
                message: "您还不是一对一洽谈创投嘉宾，请先报名成为创投嘉宾再进行预约",
                showClose: false,
                confirmButtonClass: "btn-color",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                callback: (action, instance) => {
                    if (action == "confirm") {
                        this.$router.push("/1v1/vc");
                    }
                }
            });
            return;
        }

        this.getList()
    },
    methods: {
        getList() {
            getOrderList({
                mainId: this.$session.get("cmm").mainId,
                page: {
                    pageNum: 1,
                    pageSize: 100
                }
            }).then(res => {
                if (res && res.code === 200) {
                    this.appointList = res.data.result;
                }
            })
        },
        toPage() {
            this.$router.push({
                name: 'industryScreen'
            });
        },
        cancelBtn(obj) {
            this.$msgbox({
                title: "确认信息",
                message: `确认取消于“${obj.showStartTime} - ${obj.showEndTime}”在“${obj.filmPlace}”放映的《${obj.filmName}》电影预约`,
                showClose: false,
                showCancelButton: true,
                cancelButtonClass: "cancel-btn-color",
                confirmButtonClass: "btn-color",
                callback: (action, instance) => {
                    if (action == "confirm") {
                        cancelOrder(obj.orderId).then(res => {
                            if (res && res.code === 200) {
                                this.$message.success('成功取消预约');
                                this.getList();
                            }
                        })
                    }
                }
            });
        },
        goBack() {
            this.$router.push("/userIndex");
        }
    }
}
</script>

<style src="../../static/css/oneOnOne.css" scoped></style>
<style src="../../static/css/regist.css" scoped></style>
<style src="../../static/css/infoCommon.css" scoped></style>